import React from "react";
import {
  StyledForm,
  MUIDeviceFormControl,
  MUIDeviceFormLabel,
  paddingStyle,
} from "./style.module";
import { FormMandatoryIcon } from "./FormMandatoryIcon";
import { Col } from "react-bootstrap";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { IsLoggedInUserViewer } from "../../../../hoc/withAuthRedirect";

export const FormRadio = ({
  id,
  elementkey,
  isMandatory,
  label,
  selectList,
  onSelect,
  value,
  isDisabled,
  // error,
}) => {
  const handleSelect = (e) => {
    onSelect({
      target: {
        id: e.target.parentNode.parentNode.parentNode.id,
        value: e.target.value,
      },
    });
  };
  return (
    <StyledForm.Group
      as={Col}
      //md="6"
      lg="4"
      controlId={id}
      style={paddingStyle}
      key={elementkey}
    >
      <MUIDeviceFormControl>
        <MUIDeviceFormLabel id={id + "-row-radio-buttons-group-label"}>
          {isMandatory && <FormMandatoryIcon />}
          {label}
        </MUIDeviceFormLabel>
        <RadioGroup
          row
          aria-labelledby={id + "-row-radio-buttons-group-label"}
          name={id + "row-radio-buttons"}
          onChange={handleSelect}
          value={value}
          id={id}
        >
          {selectList.map((item) => {
            return (
              <FormControlLabel
                key={item.value}
                value={item.value}
                control={<Radio disabled={isDisabled} />}
                label={<span style={{ fontSize: ".8rem" }}>{item.label}</span>}
                disabled={IsLoggedInUserViewer()}
              />
            );
          })}
        </RadioGroup>
      </MUIDeviceFormControl>
    </StyledForm.Group>
  );
};
